import React, { useRef } from "react"
import styled from "styled-components"

import { useIntersecting } from "../hooks/useIntersecting"
import SEO from "./Seo"

const StyledTitle = styled.div.attrs(({ intersecting }) => ({
  style: {
    padding: !intersecting ? "0 10px" : 0,
    paddingTop: !intersecting ? "max(10px, env(safe-area-inset-top))" : 0,
    backgroundColor: !intersecting ? "#eef4f6" : "transparent",
    margin: !intersecting ? "0" : "0 10px",
    zIndex: !intersecting ? 20 : "auto",
  },
}))`
  text-align: center;
  font-size: 29px;
  color: #707070;
  font-family: "Nunito", sans-serif;
  text-shadow: 0px 3px 6px #00000029;
  position: sticky;
  top: -1px;
  z-index: 10;
  margin-bottom: 7px;
  text-overflow: ellipsis;
  overflow: hidden;

  transition: 0.4s padding-top ease;
`

const Title = ({ children, ...rest }) => {
  const sticky = useRef()
  const intersecting = useIntersecting(sticky)

  return (
    <StyledTitle intersecting={intersecting} ref={sticky} {...rest}>
      <SEO title={children} />
      {children}
    </StyledTitle>
  )
}

export default Title
